import React, { useEffect, useState } from 'react';
import { Col, Row, Button, Table, Container, Card, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import warningIcon from '../../assets/images/status-icon.svg';
import viewIcon from '../../assets/images/icons/viewModalIcon.svg';
import editIcon from '../../assets/images/icons/icon-edit.svg';
import delIcon from '../../assets/images/icons/icon-delete.svg';
import Pagination from 'react-bootstrap/Pagination';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import VendorDelModal from '../Modals/VendorModals/VendorDelModal';
import VendorEditModal from '../Modals/VendorModals/VendorEditModal';
import VendorDetailModal from '../Modals/VendorModals/VendorDetailModal';
import DataTable from 'react-data-table-component';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import CommonModal from '../Modals/CommonModal';
import { useAuth } from '../../hooks/useAuth';
const Vendors = () => {
    const [vendors, setVendors] = useState();
    const [selectedItem, setSelectedItem] = useState();
    const [showDelModal, setShowDelModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showBulkDel, setShowBulkDel] = useState(false);
    const [activeNumber, setActiveNumber] = useState(1);
    const [offset, setOffset] = useState(0);
    const [paginationBtns, setPaginationBtns] = useState(1);
    const [routes, setRoutes] = useState();
    const [loading, setLoading] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [toggleCleared, setToggleCleared] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [buttonDisable, setButtonDisable] = useState(true);
    const [isFilterSelected, setIsFilterSelected] = useState(false);
    const [isTypeFilterSelected, setIsTypeFilterSelected] = useState(false);
    const [changeStatusModal, setChangeStatusModal] = useState(false);
    const [allUnits, setAllUnits] = useState('');
    // const [first, setfirst] = useState(second)
    const { getToken } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        getAllRoutes();
    }, []);

    useEffect(() => {
        getAllVendors();
    }, []);

    const getAllRoutes = async () => {
        const token = getToken();
        if (token) {
            setLoading(true);
            new WebApiCalls()
                .getAllRoutes(token)
                .then((res) => {
                    if (res && res?.code === 200) {
                        setRoutes((r) => {
                            const routes =
                                res.data.routes.length > 0
                                    ? res.data.routes.map((item) => {
                                          return { value: item._id, label: item.name };
                                      })
                                    : [];
                            return routes;
                        });
                        setLoading(false);
                    }
                })
                .catch((err) => {});
            setLoading(false);
        }
    };

    const handleClose = () => {
        setShowDelModal(false);
        setShowEditModal(false);
        setShowDetailModal(false);
        setChangeStatusModal(false);
        setShowBulkDel(false);
    };

    const handleDelete = async () => {
        let token = getToken();
        if (token && selectedItem?._id) {
            await new WebApiCalls()
                .deleteVendor(token, selectedItem?._id)
                .then((res) => {
                    if (res?.code === 200) {
                        toast.success('Vendor has been deleted successfully.');
                        getAllVendors();
                    } else {
                        toast.error('Oops...! Something went wrong');
                    }
                })
                .catch((err) => {});
        }
    };

    const getAllVendors = async (pageSize = 10, pageNo = 0, _status, _search) => {
        const authToken = getToken();

        if (authToken) {
            setLoading(true);
            let allVendors = await new WebApiCalls().getAllVendors(authToken, pageSize, pageNo, _status, _search);
            setVendors(allVendors?.data?.vendors);
            setTotalRecords(allVendors?.data?.totalRecord);
            // calcPagination(allVendors?.data?.totalRecord);
            setLoading(false);
        }
    };

    const columns = [
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Logo</span>
                </h6>
            ),
            selector: (row) => <img className="img-fluid table-image" src={row?.logo} />,
            center: true
            // sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Name</span>
                </h6>
            ),
            selector: (row) => row.name,
            center: true,
            sortable: true
        },
        // {
        //     name: (
        //         <h6 className="text-capitalize mt-2 text-center">
        //             <span className="fw-bold ">Location</span>
        //         </h6>
        //     ),
        //     selector: (row) => row.location,
        //     sortable: true,
        //     center: true
        // },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Latitude</span>
                </h6>
            ),
            selector: (row) => row.lat,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Longitude</span>
                </h6>
            ),
            selector: (row) => row.long,
            center: true,
            sortable: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Route</span>
                </h6>
            ),
            selector: (row) => row?.route?.name || '',
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Total Rewards</span>
                </h6>
            ),
            selector: (row) => row.noOfOffers,
            sortable: true,
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Status</span>
                </h6>
            ),
            selector: (row) => (
                <select
                    value={row?.status}
                    onChange={(e) => {
                        e.preventDefault();
                        updateSingle(row?._id, { status: e.target.value });
                    }}
                    className={row?.status === 'inactive' ? 'status-selector-inactive' : 'status-selector'}
                    aria-label="Default select example"
                >
                    <option value={'active'}>Active</option>
                    <option value={'inactive'}>Inactive</option>
                </select>
            ),
            center: true
        },
        {
            name: (
                <h6 className="text-capitalize mt-2 text-center">
                    <span className="fw-bold">Action</span>
                </h6>
            ),
            selector: (row) => (
                <div className="d-flex">
                    <div className="view-detail">
                        <OverlayTrigger delay={{ show: 300, hide: 0 }} placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>View details</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={viewIcon}
                                    alt=""
                                    onClick={() => {
                                        navigate('/vendors/vendor-detail', { state: { vendor_id: row._id, vendor_detail: row } });
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>

                    <div className="edit-detail">
                        <OverlayTrigger delay={{ show: 300, hide: 0 }} placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>Edit</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={editIcon}
                                    alt=""
                                    onClick={() => {
                                        navigate('/vendors/edit-vendor', { state: { vendor_id: row._id, vendor_detail: row } });
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>
                    <div className="del-detail">
                        <OverlayTrigger delay={{ show: 300, hide: 0 }} placement={'bottom'} overlay={<Tooltip id={`tooltip-bottom`}>Delete</Tooltip>}>
                            <div className="edit-detail">
                                <img
                                    width={15}
                                    className="me-3"
                                    src={delIcon}
                                    alt=""
                                    onClick={() => {
                                        setSelectedItem(row);
                                        setShowDelModal(true);
                                    }}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>
                </div>
            ),
            center: true
            // sortable: true
        }
    ];

    const customStyles = {
        rows: {
            style: {
                // minHeight: '72px' // override the row height
                textAling: 'center'
            }
        },
        headCells: {
            style: {
                paddingLeft: '8px', // override the cell padding for head cells
                paddingRight: '8px',
                backgroundColor: '#13aa61',
                color: 'white',
                '&:hover': {
                    cursor: 'pointer'
                }
            }
        }
        // cells: {
        //     style: {
        //         paddingLeft: '8px', // override the cell padding for data cells
        //         paddingRight: '8px'
        //     }
        // }
    };
    const handlePageChange = (pageNo) => {
        // fetchUsers(page);
        getAllVendors(pageSize, pageNo);
    };

    const handlePerRowsChange = async (pageSize, pageNo) => {
        getAllVendors(pageSize, pageNo);
        setPageSize(pageSize);
        setLoading(false);
    };

    const handleRowSelected = React.useCallback((state) => {
        const selectedIds = state.selectedRows.map((item) => {
            return item._id;
        });
        setSelectedRows(selectedIds);
    }, []);

    useEffect(() => {
        if (selectedRows && selectedRows.length > 0) {
            setButtonDisable(false);
        } else {
            setButtonDisable(true);
        }
    }, [selectedRows]);

    const searchDebounce = _.debounce((text) => {
        getAllVendors(undefined, undefined, '', text);
    }, 2000);

    const updateBulk = async (status) => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows,
                status: status
            };
            if (token)
                new WebApiCalls()
                    .updateBulkVendors(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllVendors();
                            setLoading(false);
                            toast.success(selectedRows.length > 1 ? 'Vendors have been updated successfully.' : 'Vendor has been updated successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    const updateSingle = async (selectedId, body) => {
        try {
            setLoading(true);
            const token = getToken();
            if (token)
                new WebApiCalls()
                    .updateVendor(token, body, selectedId)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllVendors();
                            setLoading(false);
                            toast.success('Vendor has been updated successfully.');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    const deleteBulk = async () => {
        try {
            setLoading(true);
            const token = getToken();
            let obj = {
                _ids: selectedRows
            };
            if (token)
                new WebApiCalls()
                    .deleteBulkVendors(token, obj)
                    .then((res) => {
                        if (res?.code === 200) {
                            getAllVendors();
                            setLoading(false);
                            toast.success(selectedRows.length > 1 ? 'Vendors have been deleted successfully.' : 'Vendor has been deleted successfully');
                            setToggleCleared(true);
                            setSelectedRows();
                        }
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
            setLoading(false);
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };
    return (
        <div style={{ padding: '20px' }}>
            <Modal centered show={changeStatusModal} onHide={handleClose} size="md">
                <Modal.Header closeButton onClick={handleClose}>
                    <Modal.Title className="text-center">
                        <h6 className="mt-2 modal-detail">Change Status</h6>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="text-center">
                    <div className="icon-warning-wrapper my-1 mt-1">
                        <img src={warningIcon} alt="" />
                    </div>
                    <p className="mx-4 my-4 px-5">Are you sure you want to change status?</p>
                    <div className="text-content-wrapper mt-3">
                        <div>
                            <Button
                                className="add-record-btn  justify-content-center w-140"
                                style={{ background: '#198754' }}
                                onClick={() => {
                                    setChangeStatusModal(false);
                                    updateBulk('active');
                                }}
                            >
                                Active
                            </Button>
                        </div>
                        <div>
                            <Button
                                className="add-record-btn  justify-content-center w-140"
                                style={{ background: '#F32013' }}
                                onClick={() => {
                                    setChangeStatusModal(false);
                                    updateBulk('inactive');
                                }}
                            >
                                Inactive
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0 mt-2"></Modal.Footer>
            </Modal>
            <CommonModal handleClose={handleClose} show={showDelModal} handleDelete={handleDelete} text={'Are you sure, you want to delete this Vendor?'} />
            <CommonModal
                handleClose={handleClose}
                show={showBulkDel}
                handleDelete={deleteBulk}
                text={selectedRows?.length > 1 ? 'Are you sure, you want to delete selected Vendors?' : 'Are you sure, you want to delete selected Vendor?'}
            />
            <Row className="mb-4 mt-1">
                <Col sm={3} md={3} style={{ paddingRight: 0 }}>
                    <input
                        type={'search'}
                        className="search-input-bar"
                        placeholder={'Search here...'}
                        onChange={(e) => {
                            e.preventDefault();
                            searchDebounce(e.target.value);
                        }}
                    />
                </Col>
                <Col sm={4} md={4} style={{ paddingLeft: 0 }}>
                    <div className="d-flex gap-10 justify-content-start my-3 my-sm-0">
                        <h6 className="text-capitalize mt-2 text-center">
                            {/* <span className="fw-bold" style={{ whiteSpace: 'nowrap' }}>
                                Filter By
                            </span> */}
                        </h6>
                        {/* <select
                            onChange={(e) => {
                                getAllVendors(undefined, undefined, e.target.value);
                                setIsTypeFilterSelected(e.target.value ? true : false);
                            }}
                            className="status-selector w-120"
                            aria-label="Default select example"
                            style={{ color: !isTypeFilterSelected ? '#9a9a9a' : '' }}
                        >
                            <option value={''}>Transit Type</option>
                            <option value={'bus'}>Bus</option>
                            <option value={'streetcar'}>Street Car</option>
                            <option value={'subway'}>Subway</option>
                            <option value={'train'}>Train</option>
                        </select> */}
                        <select
                            onChange={(e) => {
                                getAllVendors(undefined, undefined, e.target.value, '');
                                setIsFilterSelected(e.target.value ? true : false);
                            }}
                            className="status-selector w-120"
                            aria-label="Default select example"
                            style={{ color: !isFilterSelected ? '#9a9a9a' : '' }}
                        >
                            <option value={''} hidden disabled>
                                Status
                            </option>
                            <option value={'active'}>Active</option>
                            <option value={'inactive'}>Inactive</option>
                        </select>
                    </div>
                </Col>
                <Col sm={5} md={5}>
                    <div className="d-flex gap-10 justify-content-end h-100">
                        {!buttonDisable && (
                            <>
                                <Button
                                    className="add-record-btn  justify-content-center w-140"
                                    style={{ background: '#F3D119', color: 'black' }}
                                    onClick={(e) => {
                                        // updateBulk('active');
                                        setChangeStatusModal(true);
                                        // setActionType('add');
                                        // setShowAddEditModal(true);
                                    }}
                                    disabled={buttonDisable}
                                >
                                    Change Status
                                    {/* {activeButton} */}
                                </Button>
                                <Button
                                    className="add-record-btn  justify-content-center w-140"
                                    style={{ background: 'red' }}
                                    onClick={(e) => {
                                        setShowBulkDel(true);
                                        // deleteBulk();
                                        // setActionType('add');
                                        // setShowAddEditModal(true);
                                    }}
                                    disabled={buttonDisable}
                                >
                                    Delete
                                </Button>
                            </>
                        )}
                        <Button
                            className="add-record-btn justify-content-center  w-140"
                            style={{ background: '#13aa61' }}
                            onClick={() => navigate('/vendors/add-vendor')}
                        >
                            Add
                        </Button>
                    </div>
                    {/* </Col> */}
                </Col>
            </Row>
            <DataTable
                columns={columns}
                data={vendors}
                selectableRows
                pagination
                paginationServer
                paginationTotalRows={totalRecords}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                progressPending={vendors && vendors?.length >= 0 ? false : true}
                responsive
                direction="auto"
                fixedHeaderScrollHeight="300px"
                subHeaderAlign="right"
                subHeaderWrap
                customStyles={customStyles}
                onSelectedRowsChange={handleRowSelected}
                clearSelectedRows={toggleCleared}
                // defaultSortFieldId={1}
            />
        </div>
    );
};
export default Vendors;
